export default __webpack_public_path__ + "static/media/pokeball.de6feedb.svg";